import * as yup from "yup";
import { AbstractStatuses, InvitationResponse } from "../../models/abstract";
import { FormValidationModel } from "../../models/validation";

export interface AbstractSettingsData {
    cmeEnabled: boolean | null;
    cmeHours: number | null;
    invitationResponseId: number | null;
    statusId: number | null;
}

export class AbstractSettings implements FormValidationModel<AbstractSettingsData> {
    public data: AbstractSettingsData;
    public rules: yup.Schema<AbstractSettingsData>;

    public constructor() {
        this.data = {
            cmeEnabled: null,
            cmeHours: null,
            invitationResponseId: null,
            statusId: null,
        };
        this.rules = yup.object<AbstractSettingsData>().shape({
            cmeEnabled: yup.boolean().nullable(true).label("CME enabled"),
            cmeHours: yup.number().nullable(true).label("CME hours"),
            invitationResponseId: yup.number().nullable(true).oneOf(InvitationResponse.IDs, "$label is not valid").label("Invitation response"),
            statusId: yup.number().nullable(true).oneOf(AbstractStatuses.IDs, "$label is not valid").label("Abstract status"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractSettings.ts